import { Button, Input, Space } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import InfoIcon from "../../assets/icons/InfoIcon";
import { ModalComponentProps } from "../../types";
import CustomModal from "../ui/CustomModal";

type ConfirmActionModalProps = ModalComponentProps & {
  title?: string;
  isSubmit?: boolean;
  isReject?: boolean;
  isPayment?: boolean;
  isYesSubmit?: boolean;
  isLoading?: boolean;
  handleMackerSubmit?: (val?: string) => void;
  handleCheckerSubmit?: (val?: string) => void;
  handleBatchRejectSubmit?: (val?: string) => void;
};

export default function ConfirmActionModal({
  handleClose,
  title,
  isSubmit,
  isReject,
  isPayment,
  isYesSubmit,
  type,
  data,
  isLoading,
  handleMackerSubmit,
  handleCheckerSubmit,
  handleBatchRejectSubmit,
  ...rest
}: ConfirmActionModalProps) {
  const navigate = useNavigate();
  const [comment, setComment] = useState("");

  return (
    <CustomModal {...rest} handleClose={handleClose} width={400} footer={null}>
      <div className="flex items-center gap-2">
        <span className="bg-[#FFF6ED] p-1 rounded">
          <InfoIcon />
        </span>
        <span className="text-[22px] font-semibold">Confirm Action</span>
      </div>
      <div className="self-stretch justify-start text-slate-500 text-base font-normal font-['Inter'] leading-7 mt-3 mb-3">
        {title}
      </div>

      {isYesSubmit ? null : (
        <div className="mb-3">
          <label className="block text-sm font-medium text-slate-700 mb-1">
            Comment
          </label>
          <Input
            placeholder="Write your comment"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          />
        </div>
      )}

      <Space className="w-full mt-2" size={12}>
        <Button
          className="normal-dark-button modal-button !h-[40px]"
          onClick={handleClose}
          size="middle"
        >
          Cancel
        </Button>
        {isPayment && (
          <Button
            className="modal-button !h-[40px]"
            type="primary"
            htmlType="submit"
            size="middle"
            loading={isLoading}
            // onClick={() => handleOpen({ type: "VIEW" })}
          >
            Payment
          </Button>
        )}

        {isYesSubmit && (
          <Button
            className="modal-button !h-[40px]"
            type="primary"
            htmlType="submit"
            size="middle"
            loading={isLoading}
            onClick={() => handleMackerSubmit?.()}
          >
            Yes, Submit
          </Button>
        )}

        {isSubmit && (
          <Button
            className="modal-button !h-[40px]"
            type="primary"
            htmlType="submit"
            size="middle"
            onClick={() => handleCheckerSubmit?.(comment)}
            loading={isLoading}
            // disabled={!comment}
          >
            Submit
          </Button>
        )}

        {isReject && (
          <Button
            type="primary"
            size="middle"
            danger
            onClick={() => handleBatchRejectSubmit?.(comment)}
            className="w-32 !h-[40px] !bg-red-500 !border-red-500 hover:!bg-red-600 hover:!border-red-600"
            disabled={!comment}
            loading={isLoading}
          >
            Reject
          </Button>
        )}
      </Space>
    </CustomModal>
  );
}
